
export default {
  props: {
    example: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    examples() {
      return this.example
        ? ['Yanmar AF-15', 'Kubota L1-235', 'Iseki Sial 15']
        : []
    }
  },
  methods: {
    focusInput() {
      this.$refs.search.focusInput()
    },
    onChange(value) {
      if (value) {
        const route = {
          name: 'products',
          query: {
            search: value
          }
        }

        this.$navigateTo(route)
      }
    }
  }
}
